// Family sharing — pure helpers only (no Firebase/Firestore)

const normalizeSharedUser = (user) => {
  if (!user) return null;
  if (typeof user === "string") return { id: user, email: user };
  if (user?.id || user?.email) return { id: user.id || user.email, email: user.email || "" };
  return null;
};

export const normalizeSharedUsers = (list) =>
  (list || []).map(normalizeSharedUser).filter(Boolean);

export const buildSharedWithIds = (list) =>
  Array.from(
    new Set(
      (list || [])
        .map((u) => (typeof u === "string" ? u : u?.id))
        .filter(Boolean)
    )
  );

